/**
 * QR App - © 2025 Juan Pablo Marín Del Rincón. Todos los derechos reservados.
 *
 * Este sistema fue desarrollado exclusivamente para Dinámica Juvenil Sfa.
 * Se prohíbe su venta, redistribución, modificación o uso no autorizado,
 * total o parcial, sin consentimiento por escrito del autor.
 *
 * Protegido por la Ley Federal del Derecho de Autor (LFDA), Título VII:
 * - Capítulo I: Infracciones Administrativas
 * - Capítulo II: Delitos
 * - Capítulo III: Sanciones
 *
 * Cualquier uso indebido podrá ser sancionado conforme a la ley.
 * Contacto: jpmarin1999.@gmail.com
 */

import React, { useState, useEffect } from 'react';
import { sileo, Toaster } from "sileo";
import { Form, Input, Button, message, Typography, Divider, theme, App } from 'antd';
import { useNavigate } from 'react-router-dom';
//import '@ant-design/v5-patch-for-react-19';
import { LockOutlined, MailOutlined, UserOutlined } from '@ant-design/icons';
import { jwtDecode } from 'jwt-decode';
import { useAuth } from '../../context/AuthProvider';
import { getBackendUrl } from '../../utils/env';
import axios from "axios";


const { Title, Text } = Typography;

const cardAnimation = {
  animation: "cardEnter 0.6s ease-out both",
};

const animationStyle = `
@keyframes cardEnter {
  from {
    opacity: 0;
    transform: translateY(24px) scale(0.96);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
`;

export default function Login() {
  <style>{animationStyle}</style>
  const [loading, setLoading] = useState(false);
  const { Title } = Typography;
  const { token } = theme.useToken(); // 🎨 colores dinámicos
  const navigate = useNavigate();
  const auth = useAuth();
  const { message } = App.useApp();

  // ✅ Estado para detectar tema desde el body
  const [isLight, setIsLight] = useState(
    document.body.getAttribute('data-theme') === 'light'
  );

  useEffect(() => {
    const observer = new MutationObserver(() => {
      setIsLight(document.body.getAttribute('data-theme') === 'light');
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['data-theme'],
    });

    return () => observer.disconnect();
  }, []);

  if (!auth) {
    console.error("Auth context no disponible");
    return null;
  }

  const onFinish = (values) => {
    setLoading(true);

    axios
        .post(
            `${getBackendUrl()}api/auth/login.php`,
            values,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        )
        .then(res => {
            setLoading(false);

            const data = res.data;

            if (data.token) {

                auth.login(data.token);

                localStorage.setItem('token', data.token);

                const decoded = jwtDecode(data.token);

                localStorage.setItem('user_id', decoded.user_id);
                localStorage.setItem('name', decoded.name);
                localStorage.setItem('profile_picture', decoded.profile_picture);
                localStorage.setItem('gender', decoded.gender);
                localStorage.setItem('email', decoded.email);
                localStorage.setItem('points', decoded.points);

                // =========================
                // ONESIGNAL
                // =========================

                if (window.OneSignal && decoded.user_id) {
                    window.OneSignal.login(
                        decoded.user_id.toString()
                    );
                }

                // =========================
                // MENSAJE DE BIENVENIDA
                // =========================

                sileo.success({
                    title: `Bienvenid${
                        decoded.gender === 'femenino'
                            ? 'a'
                            : 'o'
                    } ${
                        decoded.name || 'Usuario'
                    }!`,

                    fill: "#fadb14",

                    duration: 10000,

                    styles: {
                        title: {
                            color: isLight
                                ? "#FFFFFF"
                                : "#000000"
                        }
                    }
                });

                // =========================
                // REDIRECCIÓN POR CORREO
                // =========================

                const email = decoded.email
                    ?.trim()
                    .toLowerCase();

                if (email === "superadmin@sentinel.com") {

                    navigate('/superadmin');

                } else if (email === "admin@example.com") {

                    navigate('/admin');

                } else if (email === "cajero@sentinel.com") {

                    navigate('/admin/kermes');

                } else {

                    navigate('/dashboard');

                }
            }
        })
        .catch(err => {

            setLoading(false);

            console.error(err);

            sileo.error({
                title: "Credenciales incorrectas",

                description:
                    "Verifique sus datos e intente nuevamente.",

                fill: "#fadb14",

                styles: {
                    title: {
                        color: isLight
                            ? "#FFFFFF"
                            : "#000000"
                    },

                    description: {
                        color: isLight
                            ? "#E5E5E5"
                            : "#333333"
                    }
                }
            });
        });
};

  return (
    <div style={{
      minHeight: "100vh",
      background: isLight
        ? "linear-gradient(135deg, #fffbe6 0%, #ffffff 100%)"
        : "linear-gradient(135deg, #141414 0%, #1f1f1f 100%)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: "20px",
    }}>
      <div style={{
        background: token.colorBgContainer,
        padding: "clamp(24px, 8vw, 48px)",
        borderRadius: 24,
        width: "100%",
        maxWidth: 400,
        boxShadow: isLight ? "0 20px 60px rgba(0,0,0,0.05)" : "0 20px 60px rgba(0,0,0,0.3)",
        border: `1px solid ${token.colorBorderSecondary}`,
      }}>
        {/* CABECERA */}
        <div style={{ textAlign: "center", marginBottom: 32 }}>
          <img
            src={isLight ? "/img/Logo-negro.png" : "/img/Logo-blanco.png"}
            alt="Logo"
            style={{ height: 80, marginBottom: 16, objectFit: 'contain' }}
          />
          <Title level={2} style={{ margin: 0 }}>Sentinel</Title>
          <Text type="secondary">Ingresa tus credenciales para acceder al sistema</Text>
        </div>

        <Form layout="vertical" onFinish={onFinish} requiredMark={false}>
          <Form.Item
            name="email"
            rules={[{ required: true, message: "Ingresa tu correo" }, { type: "email", message: "Correo inválido" }]}
          >
            <Input
              prefix={<MailOutlined style={{ color: token.colorTextDisabled }} />}
              placeholder="Correo electrónico"
              size="large"
              style={{ borderRadius: 12, height: 50, background: token.colorFillTertiary }}
              allowClear
            />
          </Form.Item>

          <Form.Item style={{ marginBottom: 8 }}>
            <Form.Item
              name="password"
              noStyle
              rules={[{ required: true, message: "Ingresa tu contraseña" }]}
            >
              <Input.Password
                prefix={<LockOutlined style={{ color: token.colorTextDisabled }} />}
                placeholder="Contraseña"
                size="large"
                style={{ borderRadius: 12, height: 50, background: token.colorFillTertiary }}
                allowClear
              />
            </Form.Item>
          </Form.Item>

          {/* RECUPERAR CONTRASEÑA */}
          <div style={{ textAlign: 'right', marginBottom: 24 }}>
            <Button
              type="link"
              size="small"
              onClick={() => navigate("/forgot-password")}
              style={{ padding: 0, height: 'auto', fontSize: 13 }}
            >
              ¿Olvidaste tu contraseña?
            </Button>
          </div>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              block
              style={{
                height: 50,
                borderRadius: 12,
                fontSize: 16,
                fontWeight: 700,
                background: "linear-gradient(90deg, #fadb14, #faad14)",
                color: "#000",
                border: "none",
                boxShadow: "0 4px 15px rgba(250, 173, 20, 0.3)"
              }}
            >
              Entrar
            </Button>
          </Form.Item>

          <Divider plain><Text type="secondary" style={{ fontSize: 12 }}>O TAMBIÉN</Text></Divider>

          <div style={{ textAlign: "center" }}>
            <Button
              type="default"
              icon={<UserOutlined />}
              onClick={() => navigate("/register")}
              block
              style={{ borderRadius: 12, height: 45 }}
            >
              Crear una cuenta nueva
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
}
